import { Tabs as TabsContainer, Tab, TabList } from '@carbon/react';
import { useHistory, useLocation } from 'react-router-dom';
import plur from 'plur';
import { DocumentResponse } from 'types/api-responses';
import { getReferrerAsSearchParam } from './utils';

const InterpretationsCount = ({ document }: { document: DocumentResponse }) => {
  const interpretationCount = document.interpretationsCount;
  return (
    <>{`${plur(
      'Interpretation',
      interpretationCount
    )} (${interpretationCount})`}</>
  );
};

const Tabs = ({ document }: { document: DocumentResponse }) => {
  const location = useLocation();
  const history = useHistory();

  const referrer = getReferrerAsSearchParam(location.search);

  return (
    <TabsContainer
      selectedIndex={location.pathname === document.href ? 0 : 1}
      onChange={({ selectedIndex }) => {
        if (selectedIndex === 0) {
          history.push(`${document.href}${referrer}`);
        } else if (selectedIndex === 1) {
          history.push(`${document.resources.interpretations.href}${referrer}`);
        }
      }}
    >
      <TabList contained>
        <Tab id="tab-document">Overview</Tab>
        <Tab id="tab-interpretations">
          <InterpretationsCount document={document} />
        </Tab>
      </TabList>
    </TabsContainer>
  );
};

export { Tabs };
